import React, { useEffect, useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
import { PixelTracker } from '../components/PixelTracker';
import { Hero } from '../components/sections/Hero';
import { Problem } from '../components/sections/Problem';
import { Solution } from '../components/sections/Solution';
import { SevenDayPlan } from '../components/sections/SevenDayPlan';
import { Modules } from '../components/sections/Modules';
import { Transformation } from '../components/sections/Transformation';
import { Bonuses } from '../components/sections/Bonuses';
import { Offer } from '../components/sections/Offer';
import { Guarantee } from '../components/sections/Guarantee';
import { Testimonials } from '../components/sections/Testimonials';
import { FAQ } from '../components/sections/FAQ';
import { SalesPopup } from '../components/SalesPopup';
function DeferredSalesPopup() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 8000);
    return () => clearTimeout(timer);
  }, []);
  if (!mounted) return null;
  return <SalesPopup data-id="element-183" />;
}
export function LandingPage() {
  return <div className="min-h-screen font-sans text-gray-900 bg-white" data-id="element-184">
      <PixelTracker data-id="element-185" />
      <CountdownTimer data-id="element-186" />

      <main data-id="element-187">
        <Hero data-id="element-188" />
        <Problem data-id="element-189" />
        <Solution data-id="element-190" />
        <SevenDayPlan data-id="element-191" />
        <Modules data-id="element-192" />
        <Transformation data-id="element-193" />
        <Bonuses data-id="element-194" />
        <Offer data-id="element-195" />
        <Guarantee data-id="element-196" />
        <Testimonials data-id="element-197" />
        <FAQ data-id="element-198" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-199">
        <p data-id="element-200">
          © {new Date().getFullYear()} MegaPack Dormir Mejor Desde el Amor.
          Todos los derechos reservados.
        </p>
        <p className="mt-2" data-id="element-201">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio no está respaldado por Facebook de ninguna manera.
        </p>
      </footer>

      <DeferredSalesPopup data-id="element-202" />
    </div>;
}